import { observer } from "mobx-react-lite";
import { useExonnHubStore } from "src/admin/modules/b2b-gate-order/components/ExonnHub/useExonnHubStore.ts";
import { useExonnHubCatalogParams } from "src/admin/modules/b2b-gate-order/components/ExonnHub/hooks/useExonnHubCatalogParams.ts";
import { useExonnHubCatalog } from "src/admin/modules/b2b-gate-order/components/ExonnHub/hooks/useExonnHubCatalog.tsx";
import { keepPreviousData } from "@tanstack/react-query";
import { ChipV2 } from "src/components/ChipV2/ChipV2.tsx";
import { Flex } from "src/components/Flex.tsx";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { TextV2 } from "src/components/TextV2/TextV2.tsx";
import * as styles from "./AppliedFilters.style.ts";

export const AppliedFilters = observer(() => {
  const { t } = useTranslation(TranslationNamespaceEnum.ExonnHubComponent);
  const store = useExonnHubStore();
  const listParams = useExonnHubCatalogParams();
  const { data: catalogData } = useExonnHubCatalog(listParams, {
    placeholderData: keepPreviousData,
  });
  const filters = catalogData?.filters || [];
  const filterModels = store.filterModels;

  if (filterModels.length === 0) {
    return null;
  }
  const handleClearFilter = () => {
    store.setFilterModels([]);
  };
  return (
    <div css={styles.root}>
      {filterModels.map((model) => {
        const filter = filters.find((filter) => filter.name === model.name);
        if (model.type === "checkbox" && filter?.type === "checkbox") {
          return model.values.map((value) => {
            const item = filter.items.find((item) => item.value === value);
            return (
              <ChipV2
                css={styles.chip}
                label={item?.label ?? value}
                onDelete={() => {
                  store.removeCheckboxFilterValue(model, value);
                }}
              />
            );
          });
        }
        if (model.type === "range" && filter?.type === "range") {
          return (
            <ChipV2
              css={styles.chip}
              label={filter.label + ":" + model.value.join("-")}
              onDelete={() => {
                store.removeFilter(model.name);
              }}
            />
          );
        }
      })}
      <Flex
        onClick={handleClearFilter}
        css={styles.resetButton}
        gap={"5px"}
        alignItems={"center"}
      >
        <i css={styles.resetIcon} className={"icon-15-reset_filter"} />
        <TextV2 variant={"body1"}>{t("resetFilters")}</TextV2>
      </Flex>
    </div>
  );
});
